// extracted by mini-css-extract-plugin
module.exports = {"tossInModal":"_2C68ER","text":"_1O8wTY","button":"VECcHj","shine-lines":"_1dlAOw"};